import {getUri} from "../../../../utils/utils";
import Icon from "../../../../components/Icon/Icon";
import {useState} from "react";
import ViewImageModal from "../../../../Modals/view-image/view-image-modal";

export default function ImagesBox({className, data, isForm, onRemove, ...props}) {
    const [isModalOpen, setIsModalOpen] = useState(false)
    return (
        <div>
            <ViewImageModal isBoxOpen={isModalOpen} setIsBoxOpen={setIsModalOpen} src={getUri(data?.file)}/>
            <div  className={`w-[100px] relative shadow-sm border-[1px] border-gray-300 h-[100px] rounded-md ${className}`}>

                {isForm && <div onClick={onRemove} className={"absolute rounded-full p-1 bg-white top-1 right-1"}>
                    <Icon name={"cross"}
                          className={"cursor-pointer w-3 h-3"} />
                </div>
                }

                <img src={getUri(data?.file)}
                     onClick={()=>setIsModalOpen(true)}
                     className={"h-full w-full rounded-md cursor-pointer object-cover"}
                     alt={"image"}/>
            </div>
        </div>

    )
}